import { useCallback, useEffect, useState } from 'react'
import { useAuth } from '../App'
import { supabase } from '../lib/supabase'

const DEFAULTS = {
  gym_enabled: true,
  gym_fragrance_ids: [],
}

export function useDailyUsePreferences() {
  const { user } = useAuth()
  const [preferences, setPreferences] = useState(DEFAULTS)
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  const fetchPreferences = useCallback(async () => {
    if (!user) return
    setLoading(true)
    setError('')
    const { data, error: queryError } = await supabase
      .from('daily_use_preferences')
      .select('gym_enabled,gym_fragrance_ids')
      .eq('user_id', user.id)
      .maybeSingle()

    if (queryError) {
      setError(queryError.message)
    } else {
      setPreferences(data || DEFAULTS)
    }
    setLoading(false)
  }, [user])

  useEffect(() => { fetchPreferences() }, [fetchPreferences])

  const savePreferences = async (patch) => {
    const next = {
      ...preferences,
      ...patch,
      gym_fragrance_ids: patch.gym_fragrance_ids ?? preferences.gym_fragrance_ids ?? [],
    }
    setSaving(true)
    setError('')
    const { data, error: saveError } = await supabase
      .from('daily_use_preferences')
      .upsert({
        user_id: user.id,
        ...next,
        updated_at: new Date().toISOString(),
      }, { onConflict: 'user_id' })
      .select('gym_enabled,gym_fragrance_ids')
      .single()

    setSaving(false)
    if (saveError) {
      setError(saveError.message)
      throw saveError
    }
    setPreferences(data)
    return data
  }

  const toggleGymScent = (fragranceId) => {
    const current = preferences.gym_fragrance_ids || []
    const next = current.includes(fragranceId)
      ? current.filter(id => id !== fragranceId)
      : [...current, fragranceId].slice(0, 5)
    return savePreferences({ gym_fragrance_ids: next })
  }

  return {
    preferences,
    loading,
    saving,
    error,
    setGymEnabled: gym_enabled => savePreferences({ gym_enabled }),
    toggleGymScent,
    refresh: fetchPreferences,
  }
}
